/* eslint-disable import/prefer-default-export */

export const OUTREACH_CHANGED = 'OUTREACH_CHANGED';
export const LAST_PIPELINE_EVENT_CHANGED = 'LAST_PIPELINE_EVENT_CHANGED';
export const PIPELINE_EVENTS_CHANGED = 'PIPELINE_EVENTS_CHANGED';
export const UNSEEN_PIPELINE_EVENTS_CHANGED = 'UNSEEN_PIPELINE_EVENTS_CHANGED';
